import type { SuiteManifest } from '../manifest';
import { webbuilderRoutes } from './routes';
import type { SuiteManifestItem } from './types';

export * from './types';

export const WEBBUILDER_SUITE_ID = 'webbuilder' as const;

export const WEBBUILDER_MODULES: readonly SuiteManifestItem[] = [
  {
    id: 'visual-editor',
    label: 'Pages & Visual Studio',
    route: '/webbuilder/pages',
    iconName: 'LayoutTemplate',
    requiredPermission: 'webbuilder.page.read',
  },
  {
    id: 'themes-tokens',
    label: 'Themes & Brand System',
    route: '/webbuilder/themes',
    iconName: 'Palette',
    requiredPermission: 'webbuilder.theme.read',
  },
  {
    id: 'cms-collections',
    label: 'CMS & Collections',
    route: '/webbuilder/collections',
    iconName: 'Database',
    requiredPermission: 'webbuilder.collection.read',
  },
  {
    id: 'erp-blocks',
    label: 'Live ERP Data Blocks',
    route: '/webbuilder/erp-blocks',
    iconName: 'Blocks',
    requiredPermission: 'webbuilder.block.read',
  },
  {
    id: 'forms-funnels',
    label: 'Forms & Conversion Funnels',
    route: '/webbuilder/forms',
    iconName: 'FileInput',
    requiredPermission: 'webbuilder.form.read',
  },
  {
    id: 'storefront-checkout',
    label: 'Storefront & Checkout',
    route: '/webbuilder/storefront',
    iconName: 'ShoppingBag',
    requiredPermission: 'webbuilder.storefront.read',
  },
  {
    id: 'domains-seo',
    label: 'Domains, TLS & SEO',
    route: '/webbuilder/domains',
    iconName: 'Globe',
    requiredPermission: 'webbuilder.domain.read',
  },
  {
    id: 'edge-analytics',
    label: 'Web Vitals & Funnel Analytics',
    route: '/webbuilder/analytics',
    iconName: 'BarChart3',
    requiredPermission: 'webbuilder.analytics.read',
  },
] as const;

export * as EditorModule from './modules/editor';
export * as ThemesModule from './modules/themes';
export * as CMSModule from './modules/cms';
export * as ErpBlocksModule from './modules/erp-blocks';
export * as FormsModule from './modules/forms';
export * as StorefrontModule from './modules/storefront';
export * as DomainsModule from './modules/domains';
export * as AnalyticsModule from './modules/analytics';

export const webbuilderManifest: SuiteManifest = {
  id: 'webbuilder',
  name: 'Website & Portal Builder',
  basePath: '/webbuilder',
  icon: 'globe',
  description: 'Visual CMS, SEO, brand themes, live ERP blocks, forms & custom domains.',
  requiredPermission: 'webbuilder.page.read',
  routes: webbuilderRoutes,
  nav: [
    { group: 'Visual Editor', label: 'Pages & Visual Studio', path: '/webbuilder/pages', icon: 'layout', status: 'live' },
    { group: 'Visual Editor', label: 'Themes & Brand System', path: '/webbuilder/themes', icon: 'palette', status: 'live' },
    { group: 'Visual Editor', label: 'CMS Collections', path: '/webbuilder/collections', icon: 'database', status: 'live' },
    { group: 'ERP & Forms', label: 'Live ERP Blocks', path: '/webbuilder/erp-blocks', icon: 'layers', status: 'live' },
    { group: 'ERP & Forms', label: 'Forms & Funnels', path: '/webbuilder/forms', icon: 'file-text', status: 'live' },
    { group: 'Operations & Growth', label: 'Storefront & Fees', path: '/webbuilder/storefront', icon: 'shopping-bag', status: 'live' },
    { group: 'Operations & Growth', label: 'Domains & TLS', path: '/webbuilder/domains', icon: 'globe', status: 'live' },
    { group: 'Operations & Growth', label: 'Web Vitals & Analytics', path: '/webbuilder/analytics', icon: 'bar-chart-3', status: 'live' },
  ],
};

export default webbuilderManifest;
